// extracted by mini-css-extract-plugin
export default {"input_box":"SearchBar_input_box__-5A5H"};